export const CompanyTypes = {
    1: 'MERCHANT',
    2: 'LTD',
    3: 'OTHER'
}